<template>
  <div>
    <!--<moduleCreateView></moduleCreateView>
    <div class="mt-3"></div>-->
    <moduleListView></moduleListView>
  </div>
</template>

<script>
export default {
  components: {
    // moduleCreateView: () => import('./../create/View'),
    moduleListView: () => import('./../list/page/View'),
  },
  data() {
    return {
      dataContainer: this,
      module: module
    }
  }
}
</script>
